import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import {MessageState, CHANGE_EVENT} from './state';
import { connect } from 'react-redux';

const TIMOUT_MS = 4000;

class MessageBar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      message: ''
    };
  }
  componentDidMount() {

    MessageState.on(CHANGE_EVENT, () => {

      this.setState({message: MessageState.get(), open: true});

      setTimeout(() => {

        this.setState({open: false});
      }, TIMOUT_MS);
    });

  }

  render() {
    return (
      <div>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center',}}
          open={this.state.open}
          message={this.state.message}
          autoHideDuration={TIMOUT_MS}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickItem: () => {
      
    }
  }
}

const mapStateToPropsRes = (state) => {

  return {
  }
}

const Comp = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(MessageBar);

export default Comp;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/messageBar/container.js